<script>
import {DateUtil} from '@/utils/date.js'
import { mapState } from 'vuex'
export default {
  name: 'driver',
  props: {
    // 用户信息，图片获取
    // userInfoDetail: {},
    // 判断当前系统用户权限
    isMasterManager: {type: Boolean, default: false},
    // 弹窗标题
    title: {type: String, default: ''},
    userProfileModel: {
      uid: {type: String, default: ''},
      lastName: {type: String, default: ''},
      firstName: {type: String, default: ''},
      lastNameKana: {type: String, default: ''},
      firstNameKana: {type: String, default: ''},
      sex: {type: Int32Array, default: ''},
      birthday: {type: String, default: ''}, // TODO
      homeAddress: {type: String, default: ''},
      homeLat: {type: String, default: ''}, // TODO
      homeLng: {type: String, default: ''}, // TODO
      homeTelephone: {type: String, default: ''},
      portableTelephone: {type: String, default: ''},
      fax: '',
      // driver详细弹出框展示
      loginId: {type: String, default: ''},
      // driver详细弹出框展示
      password: {type: String, default: ''},
      postalcode: {type: String, default: ''}, // TODO
      note: {type: String, default: ''}
    },
    userDriverProfileModel: {
      driverLicenseDeadline: {
        type: String,
        default: ''
      }
    },

    permissionRadio: null,
    userCheckbox: Boolean,
    adminCheckbox: Boolean,
    driverCheckbox: Boolean,
    transportCheckbox: Boolean,
    activityYear: 0,
    age: 0,
    inTime: '',
    driverInTime: '',
    option: {},
    birthday: '',
    transportName: ''

  },
  data () {
    return {
      resolve: ''
    }
  },
  watch: {
    'permissionRadio' (news) {
      this.permissionRadio = String(this.permissionRadio)
    }
  },
  computed: {
    ...mapState({
      password: state => state.password
    })
  },
  methods: {
    // 格式化免許証有効期限，（yyyyMMdd变换成yyyy年MM月dd日）
    formateDriverLicenseDeadline (date) {
      return DateUtil.yearMonthDay(date)
    },
    // 确定,将promise断定为完成态
    submit () {
      this.resolve('submit')
    },
    // 显示confirm弹出,并创建promise对象，给父组件调用
    confirm () {
      // 返回promise对象,给父级组件调用
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="row clearfix">
      <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-475051" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
          <div id="div_layer" class="modal-dialog" style=" width: 70%;">
            <div class="modal-content">
              <div class="modal-header" style="text-align: center;border-bottom:0px">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  <img height="30px" src="@/assets/X.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" />
                </button>
                <span class="modal-title F3-M-27" v-text="title">
                </span>
              </div>
              <div class="modal-body" style="padding-top:0px;">
                <div id="div_top">
                  <table id="tb_top">
                    <tr v-show="title==='ドライバー詳細'" style="border-bottom:2px solid rgb(148, 148, 148)">
                      <td class="td_title  F3-R-15">ユーザーID</td>
                      <td class="td_test F3-M-18">{{userProfileModel.loginId}}</td>
                      <td class="td_title F3-R-15" v-show="isMasterManager">パスワード</td>
                      <td class="td_test F3-M-18" v-show="isMasterManager">{{userProfileModel.password}}</td>
                    </tr>
                    <tr style="height:18px;">
                    </tr>
                    <tr style="border-top:2px solid rgb(148, 148, 148)">
                      <td class="td_title F3-R-15">権限</td>
                      <td class="td_test F3-M-18" colspan="3">
                        <template v-if="userCheckbox &&permissionRadio==='0' && driverCheckbox">
                          会員、 一般管理者、ドライバー
                        </template>
                        <template v-else-if="userCheckbox &&permissionRadio==='1' && driverCheckbox">
                          会員、 マスター管理者、ドライバー
                        </template>
                        <template v-else-if="userCheckbox && driverCheckbox">
                          会員、ドライバー
                        </template>
                        <template v-else-if="userCheckbox && permissionRadio==='1'">
                          会員、マスター管理者
                        </template>
                        <template v-else-if="userCheckbox && permissionRadio==='0'">
                          会員、一般管理者
                        </template>
                        <template v-else-if="permissionRadio==='0' && driverCheckbox">
                          一般管理者、ドライバー
                        </template>
                         <template v-else-if="permissionRadio==='1' && driverCheckbox">
                         マスター管理者、ドライバー
                        </template>
                        <template v-else-if="userCheckbox">
                          会員
                        </template>
                        <template v-else-if="permissionRadio==='0'">
                         一般管理者
                        </template>
                        <template v-else-if="permissionRadio==='1'">
                         マスター管理者
                        </template>
                        <template v-else-if="driverCheckbox">
                          ドライバー
                        </template>
                        <template v-else-if="transportCheckbox">
                          交通事業者
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <td class="td_title F3-R-15">フリガナ</td>
                      <td class="td_test F3-M-18">{{userProfileModel.lastNameKana+" "+userProfileModel.firstNameKana}}</td>
                      <td class="td_title F3-R-15" v-show="title!=='アカウントを編集'">生年月日</td>
                      <td class="td_test F3-M-18" v-show="title!=='アカウントを編集'">{{birthday}}</td>
                      <td class="td_title F3-R-15" v-show="title==='アカウントを編集'">パスワード</td>
                      <td class="td_test F3-M-18" v-show="title==='アカウントを編集'">{{password}}</td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15">氏名</td>
                      <td class="td_test F3-M-18">{{userProfileModel.lastName+" "+userProfileModel.firstName}}</td>
                      <td class="td_title F3-R-15" v-show="title!=='アカウントを編集'">年齢</td>
                      <td class="td_test F3-M-18" v-show="title!=='アカウントを編集'">{{age}}才</td>
                      <td class="td_title F3-R-15" v-show="title==='アカウントを編集'">生年月日</td>
                      <td class="td_test F3-M-18" v-show="title==='アカウントを編集'">{{birthday}}</td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15">性別</td>
                      <td class="td_test F3-M-18" v-if="userProfileModel.sex==1">女性</td>
                      <td class="td_test F3-M-18" v-if="userProfileModel.sex==0">男性</td>
                      <td class="td_title  F3-R-15" v-show="title!=='アカウントを編集'">登録日</td>
                      <td class="td_test F3-M-18" v-show="title!=='アカウントを編集'">{{inTime}}</td>
                      <td class="td_title F3-R-15" v-show="title==='アカウントを編集'">年齢</td>
                      <td class="td_test F3-M-18" v-show="title==='アカウントを編集'">{{age}}才</td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15">郵便番号</td>
                      <td class="td_test F3-M-18" colspan="3" v-show="title!=='アカウントを編集'">{{userProfileModel.postalcode}}</td>
                      <td class="td_test F3-M-18" v-show="title==='アカウントを編集'">{{userProfileModel.postalcode}}</td>
                      <td class="td_title  F3-R-15" v-show="title==='アカウントを編集'">登録日</td>
                      <td class="td_test F3-M-18" v-show="title==='アカウントを編集'">{{inTime}}</td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15">自宅住所</td>
                      <td class="td_test F3-M-18" colspan="3">{{userProfileModel.homeAddress}}</td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15">電話番号</td>
                      <td class="td_test F3-M-18" colspan="3">{{userProfileModel.homeTelephone}}</td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15">携帯番号</td>
                      <td class="td_test F3-M-18" colspan="3">{{userProfileModel.portableTelephone}}</td>
                    </tr>
                    <tr>
                      <td class="td_title F3-R-15">FAX</td>
                      <td class="td_test F3-M-18" colspan="3">{{userProfileModel.fax}}</td>
                    </tr>
                    <tr v-if="userCheckbox">
                      <td class="td_title F3-R-15">料金</td>
                      <td class="td_test F3-M-18" colspan="3">{{userProfileModel.passengerCost}} <span v-show="userProfileModel.passengerCost!==''&&userProfileModel.passengerCost!=null">円</span></td>
                    </tr>
                    <tr>
                      <td class="td_title  F3-R-15" style=" height: 100px;">備考</td>
                      <td class="td_test F3-M-18 tooLong" colspan="3">{{userProfileModel.note}}</td>
                    </tr>
                  </table>
                </div>
                <div id="div_bottom" v-show="driverCheckbox">
                  <div id="div_bottom_title" class="bgc3">
                    <span class="F2-M-19">ドライバー項目</span>
                  </div>
                  <div id="div_bottom_left">
                    <div id="div_bottom_left_img">
                      <img :src="option.img1" />
                      <!--  有数据时替换成userInfoDetail中对应的司机头像url-->
                      <!-- <img src="https://transportation-test.s3-ap-northeast-1.amazonaws.com/%2Ftest/img/ca5f95d2086c4413ac0f38334ffa5fd6.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20180820T045016Z&X-Amz-SignedHeaders=host&X-Amz-Expires=900&X-Amz-Credential=AKIAIKZTI2QHNFJNAEKA%2F20180820%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Signature=ebf9aa154400911ab934dbe39d0444579bbc192f7f2dc5dc00a2140b524c7404"
                        width='200px' height='280px' /> -->
                    </div>
                  </div>
                  <div id="div_bottom_right">
                    <table id="tb_bottom">
                      <tr>
                        <td class="td_title  F3-R-15">免許証有効期限</td>
                        <td class="td_test F3-M-18">{{formateDriverLicenseDeadline(userDriverProfileModel.driverLicenseDeadline)}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">ドライバー登録日</td>
                        <td class="td_test F3-M-18">{{driverInTime}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">活動年数</td>
                        <td class="td_test F3-M-18">{{activityYear}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">事故歴</td>
                        <td class="td_test F3-M-18">{{userDriverProfileModel.accidentFlag==1?'あり':'なし'}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">事故内容</td>
                        <td class="td_test F3-M-18">{{userDriverProfileModel.accidentDetails}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">行政処分</td>
                        <td class="td_test F3-M-18">{{userDriverProfileModel.sanctionFlag==1?'あり':'なし'}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">処分内容</td>
                        <td class="td_test F3-M-18">{{userDriverProfileModel.sanctionDetails}}</td>
                      </tr>
                      <tr>
                        <td class="td_title  F3-R-15">報酬対象</td>
                        <td class="td_test F3-M-18">{{userDriverProfileModel.rewardFlag==1?'あり':'なし'}}</td>
                      </tr>
                    </table>
                    <div id="div_bottom_bottom">
                      <div id="bottom_left" v-if="option.img3!==null">
                        <img :src="option.img3" />
                      </div>
                       <!-- 没有图片显示No Image -->
                      <div id="bottom_left" v-else class="bgc10 F2-M-18" style="text-align:center;line-height:269px">
                        No Image
                      </div>
                      <div id="bottom_right" v-if="option.img2!==null">
                        <img :src="option.img2" />
                      </div>
                      <!-- 没有图片显示No Image -->
                      <div id="bottom_right" v-else style="text-align:center;line-height:268.8px" class="bgc10 F2-M-18">
                        No Image
                      </div>
                    </div>
                  </div>
                </div>
                <div id="div_bottom" v-if="transportName != ''&&transportName != null">
                  <div id="div_bottom_title" class="bgc3">
                    <span class="F2-M-19">交通事業者項目</span>
                  </div>
                  <div id="div_bottom_right">
                    <table id="tb_bottom">
                      <tr>
                        <td class="td_title  F3-R-15">交通事業者</td>
                        <td class="td_test F3-M-18">{{transportName}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="modal-footer" style="border-top:0px;padding-top:0px;" v-show="title!=='ドライバー詳細'">
                  <button class="btn btn-default F2-M-24" @click="submit" data-dismiss="modal">確定</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../assets/css/globalStyle02.scss';
.label {
  font-weight:300;
}
.modal-footer {
  margin: 0 auto;
}
.modal-footer .btn-default {
  width: 40%;
  margin-right: 30%;
  border-radius: 10px;
  background: linear-gradient(#70b6ca 50%, #48a3be 50%);
  // color: #ffffff;
  // font-size: 20px;
}
#tb_top {
  width: 100%;
  border-collapse: collapse;
  border:2px solid rgb(148, 148, 148)
}
#div_top {
  width: 96%;
  margin: 0px auto;
  margin-bottom: 20px;
  // border:1px solid rgb(148, 148, 148)
}
#tb_top tr td {
  text-align: left;
  height: 30px;
  border: 1px solid rgb(148, 148, 148);
}

#tb_top .td_test {
  padding-left: 10px;
  width: 30%
}
#tb_top .td_title {
  width: 12%;
  text-align: center;
  background: $bgc8
}
#div_bottom {
  width: 96%;
  border: 2px solid rgb(148, 148, 148);
  margin: 0px auto;
  margin-bottom: 20px;
}
#div_bottom_title {
  text-align: center;
  background-color: lightgray;
}
#div_bottom_title h5 {
  margin: 0px;
  height: 30px;
  line-height: 30px;
}
#div_bottom_left {
  border-bottom: 1px solid rgb(148, 148, 148);
  border-top: 1px solid rgb(148, 148, 148);
  height: 249px;
  width: 20%;
  float: left;
}
#div_bottom_left_img {
  margin: 5px;
  background-color: gray;
  height: 80%;
}
#div_bottom_left_img img {
  width: 100%;
  height: 100%;
}
#tb_bottom {
  text-align: left;
  width: 80%;
  border-collapse: collapse;
}
#div_bottom_right tr .td_test {
  border-right: #ffffff solid 0px;
}
#div_bottom_right tr td {
  height: 30px;
  line-height: 30px;
  border: 1px solid gray;
}
#tb_bottom .td_title {
  background-color: lightgray;
  width: 160px;
  text-align: center;
  background: $bgc8;
  border: 1px solid rgb(148, 148, 148)
}
#tb_bottom .td_test {
  width: 80%;
  padding-left: 10px;
  border: 1px solid rgb(148, 148, 148);
}
#div_bottom_bottom {
  height: 280px;
  position: relative;
  width: 100%;
}
#bottom_left {
  width: 350px;
  height: 96%;
  margin: 5px;
  float: left;
  position: absolute;
  left: 380px;
  background-color: gray;
}
#bottom_right {
  width: 350px;
  height: 96%;
  margin: 5px;
  position: absolute;
  background-color: gray;
}

#div_bottom_bottom img {
  width: 100%;
  height: 100%;
}
.tooLong {
  word-wrap: break-word;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/driver.vue